import { Component, AfterViewInit, OnInit, HostListener, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { TabDirective } from 'ngx-bootstrap/tabs';

interface ClearCheckTab {
  title: string;
  content: any;
  disabled: boolean;
  active?: boolean;
  checkObject: any;
}

interface PrintCheckTab {
  title: string;
  content: any;
  disabled: boolean;
  active?: boolean;
  checkObject: any;
}

import { CheckService } from '../../../../services/accounting/check.service';
import { NotyService } from '../../../../services/common/noty.service';
import { HttpClientService } from '../../../../services/common/http-client.service';
import { UserService } from '../../../../services/users/user.service';

@Component({
  selector: 'app-check-index',
  templateUrl: './check-index.component.html',
  styleUrls: ['./check-index.component.scss']
})
export class CheckIndexComponent implements AfterViewInit {

  areTabsGenerated: boolean = false;

  bank_account_balances: Array<any> = [];

  count: number;

  checks: Array<any> = [];

  clearChecks: Array<any> = [];

  createParams: any = {
    commit: "",
    bank_id: null,
    check_ids: [],
  }

  printChecks: Array<any> = [];

  searchParams: any = {
    page: 1,
    per_page: 50,
    reversal: "hide_reversed",
  }

  searching: boolean = false;

  searchOptions: any = {
    order_by: [],
    order_direction: []
  };

  sidebarMaximized: boolean = true;

  sidebarOpen: boolean = false;

  clearCheckTabs: ClearCheckTab[] = [];

  printCheckTabs: PrintCheckTab[] = [];

  /**
   * Subscription to router events to catch page changes and matter id changes in the URL
   * @type {Subscription}
  */
  routerEventsSubscription: Subscription;

  constructor(
    private httpClientService: HttpClientService,
    private checkService: CheckService,
    private notyService: NotyService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService){
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.initialize();
    });
  }

  ngOnInit(): void {
    if(this.userService.navbarComponent){
      this.userService.navbarComponent.setAccountingMenu();
    }
    this.initialize();
  }

  ngOnDestroy() {
    this.routerEventsSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 5000);
  }

  @HostListener('window:scroll', ['$event'])
   window_scroll(event: Event) {
    this.content_sidebar_scroll();
  }

  @HostListener('window:resize', ['$event'])
   window_resize(event: Event) {
    this.content_sidebar_scroll();
  }

  initialize() {
    Object.assign(this.searchParams, this.route.snapshot.queryParams);
    this.checkService.getSearchOptions().then(response_json =>{
      console.log("getSearchOptions", response_json);
      this.searchOptions = response_json;
      if(this.searchOptions && this.searchOptions.per_page)
        this.searchParams.per_page = this.searchOptions.per_page;
      this.search()
    }).catch(getSearchOptionsError=>{
      console.log("getSearchOptionsError", getSearchOptionsError);
    });
  }

  buildCreateParams(params: any = {}){
    if(params.bank_id === this.createParams.bank_id || this.createParams.bank_id === null){
      const {check_id, ...rest} = params
      let checkIdIndex = this.createParams.check_ids.indexOf(check_id);
      if (checkIdIndex > -1) {
        this.createParams.check_ids.splice(checkIdIndex, 1);
        return
      }
      this.createParams.check_ids.push(check_id)
      Object.assign(this.createParams, rest)
    }
    else{
      this.notyService.notify("error", "Cannot Select Other Bank Type Check")
    }
  }
  create(){
    console.log("createParams", this.createParams)
    this.checkService.create(this.createParams).then(createRe=>{
      console.log("createRe", createRe)
    }).catch(createErr=>{
      console.log("createErr", createErr)
    })
  }

  clearSearch() {
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
    this.searchParams = {
      page: 1,
      per_page: 50,
      reversal: "hide_reversed"
    }
    this.search();
  }

  generateCheckTabs() {
    for(let clearCheck of this.clearChecks){
      let checkObject: any = {
        bank_id: clearCheck.bank_id,
        id: []
      }
      let tabContent = clearCheck.checks.map((check: any)=>{
        checkObject.id.push(check.id)
        return {id: "<a href=\"/checks/" + check.id + "\">" + check.id + "</a>", amount: check.amount, description: check.description}
      })
      this.clearCheckTabs.push({
        title: clearCheck.bank_name,
        content: tabContent,
        disabled: false,
        checkObject: checkObject
      })
    }
  }

  generatePrintTabs() {
    for(let printCheck of this.printChecks){
      let checkObject: any = {
        bank_id: printCheck.bank_id,
        id: []
      }
      let tabContent = printCheck.checks.map((check: any)=>{
        checkObject.id.push(check.id)
        return {id: "<a href=\"/checks/" + check.id + "\">" + check.id + "</a>", amount: check.amount, description: check.description}
      })
      this.printCheckTabs.push({
        title: printCheck.bank_name,
        content: tabContent,
        disabled: false,
        checkObject: checkObject
      })
    }
  }

  naviagateTabs(data: TabDirective): void {
    console.log("naviagateTabs", data);
  }

  search(pageEvent: any = null, isSearching: boolean | null = false) {
    if (isSearching)
      this.searching = true;
    if (pageEvent) this.searchParams.page = pageEvent.page;
    this.checkService.index(this.searchParams).then(response_json => {
      console.log("search params", this.searchParams);
      console.log("index", response_json);
      ({checks: this.checks, count: this.count, print_checks: this.printChecks, clear_checks: this.clearChecks, bank_account_balances: this.bank_account_balances} = response_json);
      if(!this.areTabsGenerated){
        this.areTabsGenerated = true
        this.generateCheckTabs();
        this.generatePrintTabs();
      }
      if (isSearching)
        this.searching = false;
      let newPageUrl: string = this.httpClientService.buildNewPageUrl(this.checkService.url, this.searchParams);
      if(window.location.href != newPageUrl)
        this.httpClientService.setNewPageUrl(newPageUrl);
    }).catch((indexError) =>{
      console.log("indexError", indexError);
      this.notyService.notify('Error loading checks', 'error');
    })
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }
}